module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/price_studio-b5e9ffcfe516222706d4279e547abbb0.jpg";